export const sendAdobeEvent = (spaType, spaUrl, spaTitle, assetLink, assetTitle, productId) => {
	try {
		const detail = {};
		if (spaType !== null) detail.spaType = spaType;
		if (spaUrl !== null) detail.spaUrl = spaUrl;
		if (spaTitle !== null) detail.spaTitle = spaTitle;
		if (assetLink !== null) detail.assetLink = assetLink;
		if (assetTitle !== null) detail.assetTitle = assetTitle.replace(/\[.*?\]/g, '');
		if (productId !== null) detail.productId = productId;

		var aepSlmstEvent = new CustomEvent('aepSlmstEvent', {
			detail: detail
		});
		document.querySelector('body').dispatchEvent(aepSlmstEvent);
	} catch (e) {
		console.warn('aepSlmstEvent Exception: ' + e);
		_satellite.logger.warn('aepSlmstEvent Exception: ' + e.message);
	}
};
